/**
 * Read the visitor's ISO 3166-1 alpha-2 country code from the `rkl_geo` cookie
 * set by Vercel middleware (sourced from `x-vercel-ip-country`).
 *
 * Returns null in local dev or when the cookie hasn't been set yet.
 */
export function getDetectedCountry(): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(/(?:^|;\s*)rkl_geo=([A-Z]{2})/);
  return match ? match[1] : null;
}
